import type { Attribution } from '@vm/shared';

/**
 * First-touch acquisition: where this device first came from (utm_source / ref / source link
 * parameters, else the referring site). Saved once and sent with the guest signup, for analytics.
 */
const KEY = 'vm.attribution';

function capture(): Attribution {
  const q = new URLSearchParams(location.search);
  const source = q.get('utm_source') ?? q.get('ref') ?? q.get('source') ?? undefined;
  const campaign = q.get('utm_campaign') ?? q.get('campaign') ?? undefined;
  let referrer: string | undefined;
  try {
    const r = document.referrer ? new URL(document.referrer) : null;
    if (r && r.hostname !== location.hostname) referrer = r.href;
  } catch {
    /* unparsable referrer */
  }
  return { ...(source ? { source } : {}), ...(campaign ? { campaign } : {}), ...(referrer ? { referrer } : {}) };
}

function load(): Attribution {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved) return JSON.parse(saved) as Attribution;
    const a = capture();
    localStorage.setItem(KEY, JSON.stringify(a));
    return a;
  } catch {
    return capture();
  }
}

export const attribution: Attribution = load();
